import styled from 'styled-components';
import { COLORS } from '../../constants/colors';

export const CalendarWrapper = styled.div`
  .ant-picker-calendar {
    background: white;
    border-radius: 12px;
    padding: 16px;
  }

  /* Remove ALL calendar default styling */
  .ant-picker-panel * {
    border: none !important;
  }

  /* Make calendar cells larger */
  .ant-picker-cell {
    padding: 8px 0 !important;
    text-align: center !important;
    position: relative !important;
    background: transparent !important;
  }

  .ant-picker-cell-inner {
    width: 40px !important;
    height: 40px !important;
    font-size: 15px !important;
    border-radius: 0 !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    margin: 0 auto !important;
    position: relative !important;
    background: transparent !important;
    border: none !important;
    box-shadow: none !important;
    outline: none !important;
  }

  /* Remove ALL pseudo-elements that create blue circles */
  .ant-picker-cell::before,
  .ant-picker-cell::after {
    content: none !important;
    display: none !important;
    border: none !important;
    background: none !important;
  }

  .ant-picker-cell-inner::before,
  .ant-picker-cell-inner::after {
    content: none !important;
    display: none !important;
    border: none !important;
    background: none !important;
  }

  /* Force today's date to have no blue circle */
  .ant-picker-cell-in-view.ant-picker-cell-today,
  .ant-picker-cell-today {
    .ant-picker-cell-inner {
      font-weight: 600 !important;
      background: transparent !important;
      border: none !important;
      box-shadow: none !important;
      outline: none !important;
    }
  }

  .ant-picker-cell-in-view.ant-picker-cell-today::before,
  .ant-picker-cell-today::before,
  .ant-picker-cell-in-view.ant-picker-cell-today::after,
  .ant-picker-cell-today::after {
    content: none !important;
    display: none !important;
  }

  /* Selected date styling - only when actually selected */
  .ant-picker-cell-in-view.ant-picker-cell-selected .ant-picker-cell-inner {
    background: ${COLORS.$primaryBlue} !important;
    color: white !important;
    border: none !important;
    border-radius: 50% !important;
  }

  .ant-picker-cell-in-view.ant-picker-cell-selected::before,
  .ant-picker-cell-in-view.ant-picker-cell-selected::after {
    content: none !important;
    display: none !important;
  }

  /* Disabled dates (past or blocked) */
  .ant-picker-cell-disabled {
    background: transparent !important;
    
    .ant-picker-cell-inner {
      color: #d9d9d9 !important;
      cursor: not-allowed !important;
      opacity: 0.5 !important;
      background: transparent !important;
      border: none !important;
    }
  }

  /* Blocked dates - light red background */
  .ant-picker-cell-disabled:not(.ant-picker-cell-in-view.ant-picker-cell-selected) .ant-picker-cell-inner {
    background: #fff1f0 !important;
  }

  /* Remove ALL hover effects */
  .ant-picker-cell:hover,
  .ant-picker-cell:hover .ant-picker-cell-inner {
    background: transparent !important;
    border: none !important;
  }

  .ant-picker-cell-in-view.ant-picker-cell-selected:hover .ant-picker-cell-inner {
    background: ${COLORS.$primaryBlue} !important;
  }

  .ant-picker-cell-disabled:hover .ant-picker-cell-inner {
    background: #fff1f0 !important;
  }

  /* Remove range selection styles */
  .ant-picker-cell-range-start,
  .ant-picker-cell-range-end,
  .ant-picker-cell-in-range {
    background: transparent !important;
    
    &::before, &::after {
      content: none !important;
      display: none !important;
    }
  }
`;
